import React, { useState, useEffect } from 'react';
import { Form }                       from 'react-bootstrap';

function EditFloatValue( { index, boxMeasured, boxValue, onBoxChanged } ) {
    const [measured, setMeasured] = useState( 0 );
    const [value,    setValue]    = useState( 0 );
    const [valid,    setValid]    = useState( true );
    const floatRegex = /^[\d]+(\.[\d]+)?$/;

    const checkValidFloat = ( n ) => {
        if ( floatRegex.test(n) !== true) { 
            return false;
        } else { 
            return true;
        }
    }
        
    useEffect(() => {
        if (typeof boxMeasured !== 'undefined') {
            setMeasured(Number(boxMeasured));
        }
    }, [boxMeasured]); // Runs when initialData changes

    useEffect(() => {
        if (typeof boxValue !== 'undefined') {
            setValue(boxValue);
            setValid(checkValidFloat( boxValue ));
        }
    }, [boxValue, checkValidFloat]); // Runs when initialData changes

    
    const handleChange = (event) => {
        const { value } = event.target;
            const v = checkValidFloat( value );
            onBoxChanged( index, value, v );
    }
    
    return( <Form.Control className={' value-input-' + measured + '-' + valid } type="text" name="value" value={value} onChange={handleChange} placeholder="Value" /> );
}

export default EditFloatValue;
